import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { PureInput } from '@alfa-bank/site-pure-input';
import { CrossMIcon } from '@alfalab/icons-glyph/CrossMIcon';
import { MagnifierMIcon } from '@alfalab/icons-glyph/MagnifierMIcon';

import { Input as Component } from './input';
import type { TInput, IDeps } from './models';
import styles from './styles.css';

export const SearchInput = createWidget<IDeps, TInput>({
    styles,
    PureInput,
    CrossMIcon,
    MagnifierMIcon,
})(Component);
